"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeAuthCookies = exports.hasAuthCookies = exports.getAuthCredentials = exports.getAuthHeaders = void 0;
const js_cookie_1 = __importDefault(require("js-cookie"));
const header_util_1 = require("./header-util");
var Cookies;
(function (Cookies) {
    Cookies["AUTH_TOKEN"] = "authToken";
    Cookies["USERNAME"] = "ssoUserName";
})(Cookies || (Cookies = {}));
const getAuthToken = () => {
    return js_cookie_1.default.get(Cookies.AUTH_TOKEN);
};
const getSsoUserName = () => {
    return js_cookie_1.default.get(Cookies.USERNAME);
};
const getAuthHeaders = () => {
    const authToken = getAuthToken();
    const username = getSsoUserName();
    return Object.assign(Object.assign({}, (authToken && { [header_util_1.Header.AUTH_TOKEN]: authToken })), (username && { [header_util_1.Header.USERNAME]: username }));
};
exports.getAuthHeaders = getAuthHeaders;
const getAuthCredentials = () => {
    const authToken = getAuthToken();
    const username = getSsoUserName();
    return {
        authToken,
        username
    };
};
exports.getAuthCredentials = getAuthCredentials;
const hasAuthCookies = () => (getAuthToken() && getSsoUserName() ? true : false);
exports.hasAuthCookies = hasAuthCookies;
const COOKIE_ATTRIBUTES = { domain: '.lwtears.com', path: '/' };
const removeAuthCookies = () => {
    js_cookie_1.default.remove(Cookies.AUTH_TOKEN, COOKIE_ATTRIBUTES);
    js_cookie_1.default.remove(Cookies.USERNAME, COOKIE_ATTRIBUTES);
};
exports.removeAuthCookies = removeAuthCookies;
